import { useState, useEffect } from 'react';
import { keywordApi } from 'src/api/keywordApi';
import toast from 'react-hot-toast';

/**
 * Custom hook to fetch and manage blacklisted keywords
 * @returns {Object} Object containing blacklisted keywords array, loading state, and error
 */
const useBlacklistedKeywords = () => {
  const [blacklistedKeywords, setBlacklistedKeywords] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchKeywords = async () => {
      try {
        setIsLoading(true);
        const keywords = await keywordApi.fetchKeywords();
        // Filter to only include blacklisted keywords
        const blacklisted = keywords?.filter((keyword) => keyword?.type === 'blacklisted' && keyword?.valid === 1);
        setBlacklistedKeywords(blacklisted?.map((k) => k?.keyword?.toLowerCase()));
      } catch (err) {
        setError(err);
        toast.error('Error fetching blacklisted keywords');
      } finally {
        setIsLoading(false);
      }
    };

    fetchKeywords();
  }, []);

  return { blacklistedKeywords, isLoading, error };
};

export default useBlacklistedKeywords;
